import React from 'react';
import Styles from './CardStore.css';
import clsx from 'clsx';

function CardStore({
  name = '',
  checked = false,
  handleCheckedChange,
  closest = false,
  areaClickable = false,
  distanceLabel = '',
  addressLabel = '',
}) {
  return (
    <>
      <div
        className={clsx({
          'card-store': true,
          'area-clickable': areaClickable,
          checked,
        })}
        onClick={
          !areaClickable
            ? undefined
            : (ev) => {
                ev.preventDefault();
                if (!handleCheckedChange) return;
                handleCheckedChange(!checked);
              }
        }
      >
        <div className="card-header">
          <span
            role="radio"
            aria-checked={checked}
            className="select-button"
            onClick={(ev) => {
              ev.preventDefault();
              if (!handleCheckedChange) return;
              handleCheckedChange(!checked);
            }}
          >
            <img
              src={
                checked
                  ? 'assets/simulador-energia-solar/jornada/ic-radio-on.svg'
                  : 'assets/simulador-energia-solar/jornada/ic-radio-off.svg'
              }
              alt=""
            />
          </span>
          <div className="card-header-info">
            <p className="card-name">{name}</p>
            <p className="card-distance">{distanceLabel}</p>
          </div>
        </div>
        <div className="card-body">
          <p className="card-address">{addressLabel}</p>

          {closest && <span className="card-next">Loja próxima de você!</span>}
        </div>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default CardStore;
